<template>
  <div>
    <c-tab
      type="horizon"
      :tabItems.sync="tabItems"
      :inlineLabel="true"
      v-model="tab"
      :dense="true"
      :height="tabHeight"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :param="popupParam"
          @insertEquipInfo="updateMode"
        />
      </template>
    </c-tab>
  </div>
</template>
1
<script>
export default {
  name: 'chem-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        mdmChemMaterialId: '',
        tabName: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      tab: 'chemInfo',
      tabItems: [
        { name: 'chemInfo', icon: 'info', label: '화학자재 기본정보', class:'tab-orange', component: () => import(`${'./chemInfo.vue'}`) },
      ],
      addTabItems: [
        { name: 'chemMsds', icon: 'dangerous', label: 'MSDS 정보', component: () => import(`${'./chemMsds.vue'}`) },
        { name: 'chemPsm', icon: 'warning_amber', label: 'PSM 정보', component: () => import(`${'./chemPsm.vue'}`) },
      ],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 36);
    },
  },
  watch: {
  },
  methods: {
    init() {
      if (this.popupParam.tabName) {
        this.tab = this.popupParam.tabName;
      }
      if (this.popupParam.mdmChemMaterialId != '') {
        this.tabItems = this.tabItems.concat(this.addTabItems);
      }
    },
    updateMode(_mdmChemMaterialId) {
      this.popupParam.mdmChemMaterialId = _mdmChemMaterialId;
      this.tabItems = this.tabItems.concat(this.addTabItems);
    },
  }
};
</script>